import { getPlayerRanking, getTeamRanking } from "../../../api";

export const fetchPlayerRanking = async ({
  discipline,
  statType,
  competitionIds = [],
  season,
  widgetConfigurationId = null,
  page = 1,
  limit = 20,
  sort = 'value_desc',
}) => {
  const { data } = await getPlayerRanking({
    discipline,
    statType,
    competitionIds,
    season,
    widgetConfigurationId,
    page,
    limit,
    sort,
  });

  return data;
};

export const fetchTeamRanking = async ({
  discipline,
  statType,
  competitionIds = [],
  season,
  widgetConfigurationId = null,
  page = 1,
  limit = 20,
  sort = 'value_desc',
}) => {
  const { data } = await getTeamRanking({
    discipline,
    statType,
    competitionIds,
    season,
    widgetConfigurationId,
    page,
    limit,
    sort,
  });

  return data;
};